import React, { useState, useEffect } from 'react';
import { getSearchHistory } from '../../services/sraSearchService';
import { useAuth } from '../../contexts/AuthContext';
import { FaHistory, FaEye, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const SearchHistorySection = () => {
  const [searches, setSearches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [total, setTotal] = useState(0);
  const { user } = useAuth();

  useEffect(() => {
    if (user && expanded) {
      fetchHistory();
    }
  }, [user, expanded]);

  const fetchHistory = async () => {
    if (loading) return;
    setLoading(true);
    
    try {
      const response = await getSearchHistory({ page: 1, limit: 5 });
      setSearches(response.searches || []);
      setTotal(response.total || 0);
    } catch (error) {
      console.error('Error fetching search history:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInHours = (now - date) / (1000 * 60 * 60);
    
    if (diffInHours < 1) {
      return 'Just now';
    } else if (diffInHours < 24) {
      return `${Math.floor(diffInHours)}h ago`;
    } else {
      return date.toLocaleDateString();
    }
  };

  if (!user) return null;

  return (
    <div className="search-history-section">
      <button
        onClick={() => setExpanded(!expanded)}
        className="search-history-toggle"
      >
        <div className="flex items-center gap-2">
          <FaHistory className="text-purple-400" />
          <span className="font-semibold text-white">
            Recent AI Searches
            {total > 0 && <span className="text-purple-300 ml-1">({total})</span>}
          </span>
        </div>
        <div className="text-purple-300">
          {expanded ? <FaChevronUp /> : <FaChevronDown />}
        </div>
      </button>

      {expanded && (
        <div className="search-history-content">
          {loading ? (
            <div className="search-history-loading">
              <div className="loading-spinner"></div>
              <span className="text-gray-300">Loading history...</span>
            </div>
          ) : searches.length === 0 ? (
            <div className="search-history-empty">
              <FaHistory className="text-gray-400 text-2xl mb-2" />
              <p className="text-gray-400">No AI searches yet</p>
              <p className="text-gray-500 text-sm">Start searching to see your history here</p>
            </div>
          ) : (
            <div className="search-history-list">
              {searches.map((search, index) => (
                <div key={index} className="search-history-item">
                  <div className="search-query">
                    <FaEye className="text-purple-400 text-sm" />
                    <span className="text-white">{search.query}</span>
                  </div>
                  <div className="search-meta">
                    <span className="text-gray-400 text-sm">
                      {search.success ? (
                        `${search.results_count || 0} results`
                      ) : (
                        'Failed'
                      )}
                    </span>
                    <span className="text-gray-500 text-sm">
                      {formatDate(search.created_at)}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchHistorySection; 